var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column"},[_c('v-card-text',{staticClass:"pa-0"},[_c('booking-summary-data')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }